import React from 'react'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Card from 'shared/Cards/Card'
import ProtectionCriteria from '../../components/Criteria/CreateCriteria'
type Props = {}

export default function CreateProtectionTemplates({}: Props) {
  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Шаблон защиты</h2>
          </div>
        </div>
        <Card type='normal' style={{ marginTop: '32px' }}>
          <ProtectionCriteria />
        </Card>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}
